__webpack_require__.p = "https://js-static.iimjobs.com/production/22.1.2/_next/";